import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-brand-green text-white relative overflow-hidden" data-id="element-56">
      <div className="absolute inset-0 bg-black/10" data-id="element-57"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-59">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-8" data-id="element-60">
            Tu perro merece que te animes a intentarlo.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-cream mb-12" data-id="element-61">
            <p data-id="element-62">
              No tienes que convertirte en chef ni estudiar nutrición canina.
            </p>
            <p data-id="element-63">
              Solo necesitas una guía simple, clara y práctica para empezar a
              preparar algo casero con más seguridad y menos dudas.
            </p>
            <p className="font-bold text-white" data-id="element-64">
              Eso es exactamente lo que encontrarás en este pack.
            </p>
            <p data-id="element-65">
              Por solo $6.36, tendrás acceso hoy mismo a la guía completa y a 5
              herramientas digitales imprimibles para cocinar, organizarte y
              cuidar mejor lo que come tu perro.
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-66">
            <CTAButton className="w-full md:w-auto md:px-12 md:py-5 text-xl shadow-2xl" data-id="element-67">
              Quiero el pack completo por $6.36
            </CTAButton>
            <p className="flex items-center justify-center gap-2 text-sm text-brand-cream mt-4 opacity-80" data-id="element-68">
              <Lock className="w-4 h-4" data-id="element-69" />
              Compra segura. Acceso inmediato. Garantía de 7 días. Producto 100%
              digital.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}